import React from 'react';
import {
  Box,
  Typography,
  Paper,
  alpha,
} from '@mui/material';
import { Language, TrendingUp, Token, Explore, Storefront } from '@mui/icons-material';
import Grid from '@mui/material/Grid';

interface ConnectionsTabProps {
  colors: any;
  glassStyle: any;
  isDark: boolean;
}

const ConnectionsTab: React.FC<ConnectionsTabProps> = ({ colors, glassStyle, isDark }) => {
  const cryptoConnections = [
    { name: 'staker.fun', url: 'https://staker.fun', icon: <TrendingUp sx={{ color: '#00C853' }} /> },
    { name: 'pump.fun', url: 'https://pump.fun', icon: <Token sx={{ color: '#FFD700' }} /> },
    { name: 'Solana Compass', url: 'https://solanacompass.com', icon: <Explore sx={{ color: '#9945FF' }} /> },
    { name: 'Magic Eden', url: 'https://magiceden.io', icon: <Storefront sx={{ color: '#E42575' }} /> },
    { name: 'CoinMarketCap', url: 'https://coinmarketcap.com', icon: <Language sx={{ color: '#3861FB' }} /> },
  ];

  return (
    <Box>
      <Typography variant="h5" fontWeight={800} color={colors.textPrimary} sx={{ mb: 1 }}>
        Connections
      </Typography>
      <Paper elevation={0} sx={{ bgcolor: colors.cardBg, borderRadius: '24px', p: 4, ...glassStyle }}>
        <Grid container spacing={2}>
          {cryptoConnections.map((item) => (
            <Grid size={{ xs: 12, sm: 6 }} key={item.name}>
              <Box 
                component="a"
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  p: 2, 
                  borderRadius: '20px', 
                  border: `1px solid ${colors.borderColor}`,
                  bgcolor: isDark ? alpha(colors.headerBg, 0.5) : '#f5f5f5',
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                  textDecoration: 'none',
                  transition: 'all 0.2s',
                  '&:hover': { 
                    bgcolor: alpha(colors.accent, 0.1), 
                    borderColor: colors.accent, 
                    transform: 'translateY(-2px)' 
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  {item.icon}
                  <Typography fontWeight={700} color={colors.textPrimary}>{item.name}</Typography>
                </Box>
                <Language fontSize="small" sx={{ color: colors.textSecondary, opacity: 0.7 }} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  );
};

export default ConnectionsTab;